import React from "react"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Logo from "./logo";
import HeaderRight from "./header-right";


const Header = () => {
    return (
            <div className="header main-booking">
                <Container>
                    <Row>
                        <Col md={4}>
                            <Logo />
                        </Col>
                        <Col className="text-end" md={8}>
                            <HeaderRight />
                        </Col>
                    </Row>
                </Container>
            </div>
           
    );
  }
  
  export default Header;